<template>
  <div ref="page" class="signature-page">
    <header class="page-header">
      <button type="button" class="back-button" @click="cancel">‹</button>
      <span>请横屏签名</span>
    </header>
    <main class="signature-card">
      <div class="hint">尊敬的客户您好，请按方向横屏签名。</div>
      <div class="transport-card">
        <button type="button" class="return-previous" @click="clearSignature">清除</button>
        <p class="signature-tip">请确保签名<span>字迹清晰</span>，并尽量填满<span>签名范围</span>。</p>
      </div>
    </main>
    <div class="canvas-placeholder-layer">
      <div class="transport-card">
        <div class="canvas-placeholder">签名范围</div>
      </div>
    </div>
    <signature-h5 ref="signature" :options="signatureOptions" @confirmEvent="handleConfirm">
      <template v-slot:default>
        <footer class="actions">
          <button type="button" class="cancel-button" @click="cancel">取消</button>
          <button type="button" class="confirm-button" @click="confirmSignature">确认签字</button>
        </footer>
      </template>
    </signature-h5>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import signatureH5 from '@jensonhui/signature-h5';
import '@jensonhui/signature-h5/lib/signatureH5.css';

Vue.use(signatureH5);

const STORAGE_KEY = 'beecargo-satisfaction-survey';

export default {
  name: 'SatisfactionSurveySignature',
  data() {
    return {
      signatureOptions: {
        minWidth: 2,
        maxWidth: 3,
        penColor: '#3d3833'
      }
    };
  },
  mounted() {
    this.enterLandscape();
  },
  beforeDestroy() {
    this.unlockOrientation();
  },
  methods: {
    async enterLandscape() {
      if (window.innerWidth >= 768) return;
      try {
        if (this.$refs.page.requestFullscreen) {
          await this.$refs.page.requestFullscreen();
        }
        if (screen.orientation && screen.orientation.lock) {
          await screen.orientation.lock('landscape');
        }
      } catch (error) {
        // 插件会按当前屏幕方向自适应；受浏览器策略限制时无法主动锁定系统方向。
      }
    },
    unlockOrientation() {
      if (screen.orientation && screen.orientation.unlock) {
        screen.orientation.unlock();
      }
    },
    clearSignature() {
      if (this.$refs.signature) {
        this.$refs.signature.clearHandle();
      }
    },
    confirmSignature() {
      this.$refs.signature.confirmHandle();
    },
    handleConfirm(signature) {
      if (typeof signature !== 'string') {
        Toast('请先完成签名');
        return;
      }
      let saved = {};
      try {
        saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      } catch (error) {}
      const answers = Object.assign({}, saved.answers, { signatureUrl: signature });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, saved, { answers })));
      this.exitFullscreen();
      this.$router.back();
    },
    cancel() {
      this.exitFullscreen();
      this.$router.back();
    },
    exitFullscreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.signature-page { 
  min-height: 100vh;
  background: #fff;
  color: #3d3833;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  ::v-deep .recruit-canvas {
    position: absolute; z-index: 2; top: 52px; right: 12px; bottom: 136px; left: 12px; width: auto; height: 70vh; border-radius: 4px; background: #fff; box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
  }
  ::v-deep .recruit-canvas .canvas-box {
    top: 62px; right: 56px; bottom: 16px; left: 16px; width: auto; height: auto; transform: none; border: 1px solid #b9b1aa; border-radius: 4px; background: transparent;
  }
  ::v-deep .recruit-canvas .canvas-box #canvas-map {
    position: relative; z-index: 2;
  }
}
.page-header { position: relative; z-index: 5; height: 44px; display: flex; align-items: center; justify-content: center; border-bottom: 1px solid #f4f4f4; background: #fff; font-size: 17px; font-weight: 500; }
.back-button { position: absolute; left: 12px; border: 0; padding: 0 6px 4px; background: transparent; color: #000; font-size: 32px; }
.signature-card { position: absolute; z-index: 3; top: 52px; right: 12px; bottom: 136px; left: 12px; pointer-events: none; }
.hint { position: absolute; top: 16px; right: 16px; left: 16px; height: 31px; border-radius: 4px; background: #f58226; color: #fff; font-size: 14px; line-height: 31px; text-align: center; }
.transport-card { position: absolute; top: 50%; left: 50%; width: calc(100vh - 188px); height: calc(100vw - 24px); transform: translate(-50%, -50%) rotate(90deg); transform-origin: center; }
.canvas-placeholder-layer { position: absolute; z-index: 3; top: 52px; right: 12px; bottom: 136px; left: 12px; pointer-events: none; }
.canvas-placeholder { position: absolute; top: 62px; bottom: 16px; left: 25px; width: calc(100% - 56px); display: flex; align-items: center; justify-content: center; border-radius: 4px; color: #8b8b8b; font-size: 100px; font-weight: 500; line-height: 1.1; text-align: center; opacity: .2; pointer-events: none; }
.return-previous { position: absolute; z-index: 4; top: 10px; left: 11%; width:112px; height: 32px; padding: 8px 6px; border: 1px solid #f1892e; border-radius: 4px; background: #fff; color: #f1892e; font-size: 16px; line-height: 16px; pointer-events: auto; }
.signature-tip { width:100%;position: absolute; top: 15px; left: 33%; margin: 0; color: #3d3833; font-size: 14px; line-height: 22px; }
.signature-tip span { color: #f1892e; }
.actions { position: fixed; z-index: 10; right: 12px; bottom: 42px; left: 12px; display: flex; gap: 15px; }
.actions button { flex: 1; height: 48px; border-radius: 4px; font-size: 16px; }
.cancel-button { border: 1px solid #f1892e; background: #fff; color: #f1892e; }
.confirm-button { border: 1px solid #f1892e; background: #f1892e; color: #fff; }
.signature-page:fullscreen { width: 100vw; height: 100vh; }

@media (min-width: 768px) {
  .signature-page {
    background: #f7f7f7;

    ::v-deep .recruit-canvas {
      top: 64px;
      right: calc(50% - 360px);
      bottom: 92px;
      left: calc(50% - 360px);
      width: auto;
      height: auto;
      border-radius: 8px;
    }
    ::v-deep .recruit-canvas .canvas-box {
      top: 112px;
      right: 24px;
      bottom: 24px;
      left: 24px;
      border-radius: 6px;
    }
  }
  .signature-card,
  .canvas-placeholder-layer {
    top: 64px;
    right: calc(50% - 360px);
    bottom: 92px;
    left: calc(50% - 360px);
  }
  .transport-card {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    height: auto;
    transform: none;
  }
  .hint {
    top: 16px;
  }
  .return-previous {
    top: 66px;
    left: 24px;
    width: 88px;
    cursor: pointer;
  }
  .signature-tip {
    top: 71px;
    left: 136px;
    width: auto;
  }
  .canvas-placeholder {
    top: 112px;
    right: 24px;
    bottom: 24px;
    left: 24px;
    width: auto;
    font-size: 64px;
  }
  .actions {
    right: auto;
    bottom: 24px;
    left: 50%;
    width: 720px;
    transform: translateX(-50%);
  }
  .actions button,
  .back-button {
    cursor: pointer;
  }
}
</style>
